import { accountProvider } from "./providers/account";
import { validateEliminaAccountRequest, validateModificaAccountRequest } from "./schemas/accountSchemas";

const accountService = {
  modificaAccount: async (payload) => {
    const validated = validateModificaAccountRequest(payload);
    return accountProvider.modificaAccount(validated);
  },
  eliminaAccount: async (payload) => {
    const validated = validateEliminaAccountRequest(payload);
    return accountProvider.eliminaAccount(validated);
  },
  getVendorProfile: async () => {
    return accountProvider.getVendorProfile();
  },
};

export default accountService;